import request from '@/utils/request'
const host = process.env.VUE_APP_PRODUCT_API;

/**
 * 查询一级分类
 * @returns {*}
 */
export function getTopCategory() {
  let url = host + "/category/getLevel1Category"
  return request.get(url)
}

/**
 * 查询123级分类
 * @returns {*}
 */
export function getAllMainCategory() {
  let url = host + "/category/getAllCategory"
  return request.get(url)
}

//通过分类id查询他的上级分类
export function getUpCategoryID(categoryId){
  let url = host + "/category/getUpCategoryID/"
  return request.get(url+categoryId)
}

//通过分类id查询他的上级分类
export function getProductCategoryStandardInfo(id) {
         let url =
           host +
           "/pms-product-category-standard/getProductCategoryStandardInfo";
         return request.get(url +  (id?('/?id=' + id):''));
       }
// 自定义包装查询
export function searchProductDetailByProductCode(params) {
  return request({
    url: host+'pms-product-detail/searchProductDetailByProductCode',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/category.js